import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import * as highcharts from "highcharts";
import { isEqual } from "lodash";
import { h } from "preact";
import { ApiBackedComponent } from "../../common/components/ApiBackedComponent";
import { MakeAuditTraceApiCall } from "../../common/generic/generic-auditrace-api";
import { GenericResponse } from "../../common/generic/generic-types";
import { query } from "../../common/utils/AuditTrace/api";
import { filterConstants } from "../../common/utils/AuditTrace/constants";
import { HighChartsPreact } from "../../common/utils/AuditTrace/highcharts/highChartsPreact";
import { fromStyleLocals } from "../../common/utils/AuditTrace/style/css";
import { ICprSnapshotProps } from "../../common/utils/AuditTrace/types";
import { ICprSnapshotCompareState } from "../../cpr-snapshot-compare/model";
import {
  getOptions,
  getSeries,
} from "../service/snapshot-compare.charts.service";
import * as stylesheet from "./snapshot-compare.less";

// tslint:disable-next-line:no-var-requires
require("highcharts/highcharts-more")(highcharts);

const css = fromStyleLocals(stylesheet.locals);

export class SnapshotCompareContainerClass extends ApiBackedComponent<
  ICprSnapshotProps & IWidgetConfigurationProps,
  ICprSnapshotCompareState
> {
  public constructor() {
    super();
    this.setState({
      data: {},
    });
  }

  public renderWithDataReady(): JSX.Element {
    const series = getSeries(
      this.state.data,
      this.props.filters.photoStart,
      this.props.filters.photoEnd
    );
    const options = getOptions(series);
    return (
      <div class={css("snapshot-compare")}>
        <style>{stylesheet.toString()}</style>
        <HighChartsPreact
          class={css("chart-container")}
          options={options as any}
        />
      </div>
    );
  }

  protected shouldFetchApiData(nextProps: ICprSnapshotProps) {
    return !isEqual(this.props.filters, nextProps.filters);
  }

  protected async fetchApiData(io: ICprSnapshotProps) {
    this.initCorrelationId();
    this.setDataStatus("loading");
    const user = this.props.widgetConfiguration.bus.dangerouslyGetCurrentValue<
      []
    >("sg-connect.user-connection");

    const email =
      user !== undefined ? user["mail" as any] : "william.eglenne@sgcib.com";
    const filters = this.GetFilters(io, email);

    const snapshotCompareQuery = query(`api/SnapshotCompare/compared`, filters);

    const responseData = await MakeAuditTraceApiCall(
      io.headers,
      snapshotCompareQuery,
      null,
      this.props.widgetConfiguration,
      this.state.correlationId
    );
    if (this.handleError(responseData)) {
      this.setState({
        data: [],
      });
    } else if (responseData.data) {
      if (responseData.data.length !== 0) {
        this.setState({
          data: responseData.data,
        });
        this.setDataStatus("ready");
      } else {
        this.setState({
          data: [],
        });
        this.setDataStatus("no-data");
      }
    }
  }

  private GetFilters(io: ICprSnapshotProps, email: string) {
    return {
      bdrCommercialId:
        io.filters.bdrCommercialId === undefined
          ? 0
          : io.filters.bdrCommercialId,
      bdrCommercialLevel:
        io.filters.bdrCommercialLevel === undefined
          ? ""
          : io.filters.bdrCommercialLevel,
      coriGrpCountryAxis:
        io.filters.clienthist_corigrpcountryaxis === undefined
          ? []
          : this.GetSelectorsValue(io.filters.clienthist_corigrpcountryaxis),
      coriGrpSegment:
        io.filters.clienthist_corigrpsegment === undefined
          ? []
          : this.GetSelectorsValue(io.filters.clienthist_corigrpsegment),
      finalDate: this.GetDate(io.filters.finalDate, io.filters.initialDate),
      finalKpi: this.GetDefaultValueForKpi(
        io.filters[filterConstants.finalKPIAttribute]
      ),
      grpSegment:
        io.filters.clienthist_grpsegment === undefined
          ? []
          : this.GetSelectorsValue(io.filters.clienthist_grpsegment),
      initialDate: this.GetDate(io.filters.initialDate, io.filters.finalDate),
      initialKpi: this.GetDefaultValueForKpi(
        io.filters[filterConstants.initialKPIAttribute]
      ),
      isCoriView: io.filters[filterConstants.clientVisionAttribute]
        ? io.filters[filterConstants.clientVisionAttribute][0] === "2"
        : false,
      leSegment:
        io.filters.clienthist_lesegment === undefined
          ? []
          : this.GetSelectorsValue(io.filters.clienthist_lesegment),
      photoEnd: io.filters.photoEnd,
      photoStart: io.filters.photoStart,
      userEmail: email,
      withDetails: false,
    };
  }
  private handleError(
    responseData: GenericResponse,
    setDataStatus = true
  ): boolean {
    if (responseData.noAccessRights) {
      if (setDataStatus) {
        this.setDataStatus("no-access-rights");
        this.setStatusText(responseData.statusText);
      }
      return true;
    } else if (responseData.serverError) {
      if (setDataStatus) {
        this.setDataStatus("server-error");
      }
      return true;
    }
    return false;
  }

  private GetDefaultValueForKpi(value: string) {
    return value === undefined ? "nbi_ytd" : value[0];
  }
  private GetDate(value: string, date: string) {
    return value === undefined ? date : value;
  }
  private GetSelectorsValue(selectorValue: any) {
    if (selectorValue[0] === null) {
      return null;
    }
    return selectorValue;
  }
}
export const SnapshotCompareContainer = withWidgetConfiguration(
  SnapshotCompareContainerClass
);
